import script from "./QueueTable.vue?vue&type=script&setup=true&lang=js"
export * from "./QueueTable.vue?vue&type=script&setup=true&lang=js"

import "./QueueTable.vue?vue&type=style&index=0&id=468616a9&lang=less"

const __exports__ = script;

export default __exports__